import { Controller } from "@hotwired/stimulus"

// Adatta il form fornitore al tipo selezionato: etichette e placeholder di
// ragione sociale / partita IVA cambiano, e il campo "Referente" sparisce per
// la persona fisica (la persona È il referente). Il valore di contact_name non
// viene azzerato: se un fornitore torna azienda il dato è ancora lì.
export default class extends Controller {
  static targets = [
    "radio", "nameLabel", "nameInput", "vatLabel", "vatInput", "contactField",
    "photoFrame", "companyIcon", "personIcon"
  ]

  static values = {
    nameCompanyLabel: String,
    namePersonLabel: String,
    nameCompanyPlaceholder: String,
    namePersonPlaceholder: String,
    vatCompanyLabel: String,
    vatPersonLabel: String,
    vatCompanyPlaceholder: String,
    vatPersonPlaceholder: String
  }

  connect() {
    this.refresh()
  }

  refresh() {
    const person = this.selectedKind === "person"

    this.nameLabelTarget.textContent = person ? this.namePersonLabelValue : this.nameCompanyLabelValue
    this.nameInputTarget.placeholder = person ? this.namePersonPlaceholderValue : this.nameCompanyPlaceholderValue
    this.vatLabelTarget.textContent = person ? this.vatPersonLabelValue : this.vatCompanyLabelValue
    this.vatInputTarget.placeholder = person ? this.vatPersonPlaceholderValue : this.vatCompanyPlaceholderValue

    this.contactFieldTarget.classList.toggle("hidden", person)
    this.refreshPhotoPreview(person)
  }

  // L'anteprima segue il tipo: tonda per la persona fisica, squadrata per
  // l'azienda, con l'icona corrispondente quando non c'è ancora una foto.
  refreshPhotoPreview(person) {
    if (this.hasPhotoFrameTarget) {
      this.photoFrameTarget.classList.toggle("rounded-full", person)
      this.photoFrameTarget.classList.toggle("rounded-lg", !person)
    }
    if (this.hasCompanyIconTarget) this.companyIconTarget.classList.toggle("hidden", person)
    if (this.hasPersonIconTarget) this.personIconTarget.classList.toggle("hidden", !person)
  }

  get selectedKind() {
    const checked = this.radioTargets.find((radio) => radio.checked)
    return checked ? checked.value : "company"
  }
}
